export default {"src":"/_next/static/media/MDT.60f2e5a5.svg","height":18,"width":18};